import React from "react";
import styles from "../../style/travelwork.module.scss";

const steps = [
  {
    id: 1,
    title: "Search Flights",
    description: "Enter your travel details to explore available flights.",
    image: "https://cdn-icons-png.flaticon.com/512/3176/3176292.png", // Search Icon
  },
  {
    id: 2,
    title: "Compare & Choose",
    description: "Review options and select the best flight for your needs.",
    image: "https://cdn-icons-png.flaticon.com/512/3176/3176369.png", // Comparison Icon
  },
  {
    id: 3,
    title: "Book & Fly",
    description: "Confirm your booking and enjoy a smooth journey.",
    image: "https://cdn-icons-png.flaticon.com/512/3176/3176294.png", // Airplane Icon
  },
];

const TravelWork = () => {
  return (
    <section className={styles.howItWorks}>
      <div className={styles.container}>
        <h2 className={styles.heading}>How it Works?</h2>
        <div className={styles.steps}>
          {steps.map((step) => (
            <div className={styles.step} key={step.id}>
              <img src={step.image} alt={step.title} className={styles.image} />
              <div className={styles.text}>
                <h4>{step.title}</h4>
                <p>{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TravelWork;
